module.exports = __webpack_public_path__ + "img/george-thompson.1cf62c38.png";